import { NormalizedError } from '@shared/error';

export const SET_ERROR = 'ERROR/SET_ERROR' as const;
export const CLEAR_ERROR = 'ERROR/CLEAR_ERROR' as const;

export const setError = (payload: NormalizedError) => ({
	type: SET_ERROR,
	payload
});

export const clearError = () => ({
	type: CLEAR_ERROR,
	payload: null as null
});

export type SetErrorAction = ReturnType<typeof setError>;
export type ClearErrorAction = ReturnType<typeof clearError>;

export type ActionErrorTypes = SetErrorAction | ClearErrorAction;
